import React from 'react';
import { useCart } from '../context/CartContext';
import './CartFloatingBar.css';

const CartFloatingBar = ({ onOpenCart }) => {
  const { items, totalCount } = useCart();

  if (!onOpenCart || totalCount === 0) return null;

  const totalPrice = items.reduce(
    (sum, i) => sum + (Number(i.price) || 0) * (i.quantity || 1),
    0
  );
  const hasPrice = totalPrice > 0;

  return (
    <div className="cart-floating-bar" role="banner" aria-label="ملخص السلة">
      <div className="cart-floating-bar-inner">
        <div className="cart-floating-bar-info">
          <span className="cart-floating-bar-count">
            {totalCount} {totalCount === 1 ? 'قطعة' : 'قطعة'} في السلة
          </span>
          {hasPrice && (
            <span className="cart-floating-bar-total">
              الإجمالي: {totalPrice.toFixed(2)} د.ل
            </span>
          )}
        </div>
        <button
          type="button"
          className="cart-floating-bar-btn"
          onClick={onOpenCart}
          aria-label="عرض السلة وإكمال الطلب"
        >
          استمر للشراء
        </button>
      </div>
    </div>
  );
};

export default CartFloatingBar;
